import { render, staticRenderFns } from "./ProgramaUniversidadSedeLayout.vue?vue&type=template&id=48ef94fd"
import script from "./ProgramaUniversidadSedeLayout.vue?vue&type=script&lang=js"
export * from "./ProgramaUniversidadSedeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports